import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useHookTrackWizardStore } from '@/store/hook-track/wizardStore';
import { HookTrackCard } from './HookTrackCard';

export function TrafficDistributionStep() {
  useLanguage();
  const { data, updatePercentage } = useHookTrackWizardStore();
  const { selectedIntros, trafficDistribution } = data;

  const handlePercentageChange = (introId: string, newPercentage: number) => {
    updatePercentage(introId, newPercentage);
  };

  return (
    <div className="flex flex-col animate-fade-in w-full max-w-6xl mx-auto pb-6">
      {/* Header */}
      <div className="flex-shrink-0 px-4 sm:px-6 lg:px-8 pt-4 lg:pt-6">
        <h2 className="text-[20px] lg:text-[22px] font-semibold text-foreground">
          {translateInterfaceText("Distribuição de Tráfego")}</h2>
        <p className="text-[15px] text-muted-foreground mt-1.5 leading-relaxed">
          {translateInterfaceText("Defina a porcentagem de tráfego que cada intro receberá no teste.")}</p>
      </div>

      {/* Intros Grid */}
      <div className="flex-1 overflow-y-auto px-4 sm:px-6 lg:px-8 mt-6 pb-16 lg:pb-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-5">
          {selectedIntros.map((intro, index) => (
            <HookTrackCard
              key={intro.id}
              intro={intro}
              index={index}
              percentage={trafficDistribution.percentages[intro.id] || 0}
              onPercentageChange={handlePercentageChange}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
